import React, { useEffect, useState } from 'react';
import './loading.css'; // Archivo de estilos

export const BlinkBlurRectangles = ({ color = '#f58705', size = 'medium', text = '', speed = 500, isVisible = false }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Cambia el índice activo para simular el efecto de iluminación secuencial
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 6);  // Cambia el índice entre 0, 1, 2, 3, 4, 5
    }, speed);

    return () => clearInterval(interval);
  }, [speed]);

  // Definimos el tamaño de los cuadrados
  const sizeStyles = {
    small: { width: '40px', height: '40px' },  // Cuadrado pequeño
    medium: { width: '50px', height: '50px' }, // Cuadrado mediano
    large: { width: '60px', height: '60px' },  // Cuadrado grande
  };

  // Estilos de los cuadrados
  const squareStyle = (index) => ({
    ...sizeStyles[size] || sizeStyles.medium,
    margin: '2px', // Menos margen para que los cuadrados estén más pegados
    backgroundColor: index === activeIndex ? color : '#e0e0e0', // Ilumina el cuadrado actual
    transition: 'background-color 0.3s ease',
    borderRadius: '0', // Sin bordes redondeados
  });

  // Estilo del contenedor para alinear los cuadrados y el texto
  const containerStyle = {
    display: isVisible ? 'flex' : 'none', // Controla la visibilidad tanto de los cuadrados como del texto
    flexDirection: 'column', // Coloca el texto debajo de los cuadrados
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  };

  // Estilo del texto debajo de los cuadrados, con color dinámico igual al del cuadrado activo
  const textStyle = {
    color: color, // El color del texto es el mismo que el de los cuadrados iluminados
    fontSize: '14px',
    textAlign: 'center',
    marginTop: '15px',
    padding: '0 10px',
  };

  // Función para procesar el texto y dividirlo por saltos de línea
  const renderTextWithLineBreaks = (text) => {
    return text.split("\n").map((line, index) => (
      <div key={index}>{line}</div> // Cada línea será un div separado
    ));
  };

  return (
    <div style={containerStyle}>
      <div style={{ display: 'flex' }}>
        {[0, 1, 2, 3, 4, 5].map((index) => (
          <div key={index} style={squareStyle(index)}></div>
        ))}
      </div>
      {text && <div style={textStyle}>{renderTextWithLineBreaks(text)}</div>} {/* Procesamos y renderizamos el texto */}
    </div>
  );
};


export const BlinkBlurCubes = ({isVisible = false })=>{
  const containerStyle = {
    display: isVisible ? '' : 'none',
  };
  return(
    <div style={containerStyle}>
      <div className="loading-container">
          <div className="box">📦</div>
          <div className="box">📦</div>
          <div className="box">📦</div>
          <div className="box">📦</div>
          <div className="box">📦</div>
      </div>
      <span className="loading-text">Procesando...!</span>
      <br/>
      <p className="loading-text-info">(Este proceso tardará varios minutos).</p>
    </div>
  );
}

// export default BlinkBlurRectangles;
